/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISpecialityVitals } from 'app/shared/model/speciality-vitals.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { IAppointments } from 'app/shared/model/appointments.model';

export interface IPrescriptionSpecVital {
  id?: string;
  active?: boolean | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  cursor?: number;
  observation?: string | null;
  comments?: string | null;
  specVital?: ISpecialityVitals | null;
  patient?: IGlucoUser | null;
  prescription?: IPrescription | null;
  appointment?: IAppointments | null;
}

export const defaultValue: Readonly<IPrescriptionSpecVital> = {
  active: false,
};
